import * as React from 'react';
import { RouteObject } from 'react-router-dom';

const AdminLoans = React.lazy(() => import(/* webpackChunkName: "admin-loans" */ '../../../../containers/Admin/Loans'));
const AdminLoansTable = React.lazy(
    () => import(/* webpackChunkName: "admin-loans-table" */ '../../../../containers/Admin/Loans/children/LoansTable')
);
const AdminLoanInfo = React.lazy(
    () => import(/* webpackChunkName: "admin-loans-info" */ '../../../../containers/Admin/Loans/children/LoanInfo')
);

export const AdminLoansRoutes: RouteObject = {
    path: 'loans',
    element: (
        <React.Suspense fallback={<>...</>}>
            <AdminLoans />
        </React.Suspense>
    ),
    children: [
        {
            index: true,
            element: (
                <React.Suspense fallback={<>...</>}>
                    <AdminLoansTable />
                </React.Suspense>
            )
        },
        {
            path: 'loan/:loanId',
            element: (
                <React.Suspense fallback={<>...</>}>
                    <AdminLoanInfo />
                </React.Suspense>
            )
        }
    ]
};
